/* eslint-disable */
import React, { useState } from "react";
import Wrapper from "../components/Wrapper";
import Option from "../components/Option";
import Button from "../components/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  addScreenAction,
  updateScreenAction,
  backScreenAction,
} from "../actions";
import {
  RESULT,
  TANK_GROUND,
  QUESTION5,
  INTENDED_APP,
  QUESTION4,
  WATER_SOURCE,
  GARDEN_TAPS,
} from "../constants";

function Question6({ screens, updateScreen, backScreen}) {
  const [aboveGround, setAboveGround] = useState(false);
  const [belowGround, setBelowGround] = useState(false);
  const isBtnDisabled = !aboveGround && !belowGround;
  const isGarden = screens.answers.INTENDED_APP === "garden";
  const isGardenTaps = screens.answers.GARDEN_TAPS;
  const isHouseAndGarden = screens.answers.INTENDED_APP === "house_and_garden";
  const isTankwater = screens.answers.WATER_SOURCE === "tank_water";
  const isMainsAndTankwater = screens.answers.WATER_SOURCE === "mains_and_tank";
  const showQue5 = isMainsAndTankwater && isHouseAndGarden;

  const options = [
    {
      name: "Above Ground",
      iconName: "above-ground-tank",
      optionClassName: `${
        aboveGround ? "c-quiz_options--option-selected" : ""
      }`,
      action: () => {
        setAboveGround(true);
        setBelowGround(false);
      },
    },

    {
      name: "Below Ground",
      iconName: "below-ground-tank",
      optionClassName: `${
        belowGround ? "c-quiz_options--option-selected" : ""
      }`,
      action: () => {
        setAboveGround(false);
        setBelowGround(true);
      },
    },
  ];

  const getAnswer = () => {
    if (aboveGround) {
      return "above_ground";
    } else {
      return "below_ground";
    }
    return undefined;
  };

  return (
    <Wrapper
      stepNo={"6"}
      question={`${
        showQue5 ? "5" : "6"
      }. Will an above ground or below ground tank be used?`}
    >
      <div
        className="uk-child-width-expand@s uk-grid-match uk-text-center c-quiz_options"
        uk-grid="margin: uk-margin-small uk-margin@s"
      >
        {options.map((option) => {
          return (
            <Option
              key={`opt_${option.name}`}
              name={option.name}
              iconName={option.iconName}
              description={option.description}
              optionClassName={option.optionClassName}
              onClick={option.action}
            />
          );
        })}
      </div>

      <Button
        text={"Back"}
        secondary
        onClick={() => {
          if (isGarden) {
            if (isGardenTaps < 5)
              backScreen({
                back_screen: QUESTION5,
                answer: isGardenTaps,
              });
          } else if (isHouseAndGarden && isMainsAndTankwater) {
            backScreen({
              back_screen: QUESTION4,
            });
          } else if (isHouseAndGarden && isTankwater) {
            backScreen({
              back_screen: QUESTION5,
            });
          
          } else {
            backScreen({
              back_screen: QUESTION4,
            });
          }
        }}
      />

      <Button
        text={"see my results"}
        disabled={isBtnDisabled}
        onClick={() => {
          const ans = getAnswer();
          updateScreen({
            curr_screen: TANK_GROUND,
            next_screen: RESULT,
            answer: ans,
          });
        }}
      />
    </Wrapper>
  );
}

const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
      backScreen: backScreenAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Question6);
